import React, { ReactNode, useEffect } from 'react';
import PIECard, { PIECardModes } from '@src/shared/components/PIECard';
import styles from './DashboardAdvertiseCard.module.scss';
interface componentProps {
  image?: ReactNode;
  title: ReactNode;
  description: ReactNode;
  insertTop?: ReactNode;
  insertLeft?: ReactNode;
  onClick?: () => void;
  className?: string;
  elevation?: Boolean;
}
const DashboardAdvertiseCard = ({
  image,
  title,
  description,
  insertTop,
  insertLeft,
  onClick,
  className,
  elevation = true,
}: componentProps) => {
  return (
    <PIECard
      modElevation={elevation}
      className={className}
      modBackground={true}
      mode={PIECardModes.REGULAR}
      onClick={onClick}
    >
      <div className={styles.DashboadAdvertiseCardContainer}>
        {insertLeft && (
          <div className={styles.DashboadAdvertiseCardContainerLeftWrapper}>
            {insertLeft}
          </div>
        )}
        <div className={styles.DashboadAdvertiseCardContainerCenterWrapper}>
          {insertTop}
          {title}
          {description}
        </div>
        {image && (
          <div className={styles.DashboadAdvertiseCardContainerRightWrapper}>
            {image}
          </div>
        )}
      </div>
    </PIECard>
  );
};

export default DashboardAdvertiseCard;
